import React, { ReactNode } from 'react';
import { Typography } from 'glints-aries/es/@next';
import { Blue } from 'glints-aries/es/@next/utilities/colors';

export const StyledLink = ({
  children,
  link,
}: {
  children: ReactNode;
  link: string;
}) => (
  <a href={link} target="_blank" rel="noreferrer">
    <Typography as="span" color={Blue.S99} style={{ cursor: 'pointer' }}>
      {children}
    </Typography>
  </a>
);

export const CTAText = ({
  children,
  onClick,
}: {
  children: ReactNode;
  onClick: () => void;
}) => (
  <span onClick={() => onClick()}>
    <Typography as="span" color={Blue.S99} style={{ cursor: 'pointer' }}>
      {children}
    </Typography>
  </span>
);
